import React from "react";
import { Container, Load } from "./styles";

const Loader = () => (
  <Container>
    <Load />
  </Container>
);

export default Loader;
